import React, { useState } from 'react';
import { Volume2, Loader2 } from 'lucide-react';
import { api, apiAudioUrl } from '@/lib/api';

export default function SpeakerButton({ text, languageSlug, wordId, size = 18, label = 'Play pronunciation' }) {
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState(null);

    const play = async () => {
        if (loading) return;
        try {
            setLoading(true);
            let audioUrl = url;
            if (!audioUrl) {
                if (wordId) {
                    const { data } = await api.get(`/audio/word/${wordId}`);
                    audioUrl = data.cdn_url;
                } else if (text) {
                    const { data } = await api.post('/audio/speak', { text, language_slug: languageSlug });
                    audioUrl = data.cdn_url;
                }
                if (!audioUrl) throw new Error('no audio');
                setUrl(audioUrl);
            }
            const audio = new Audio(apiAudioUrl(audioUrl));
            audio.play().catch(() => {});
        } catch {
            // browser TTS fallback
            if ('speechSynthesis' in window && text) {
                const u = new SpeechSynthesisUtterance(text);
                window.speechSynthesis.speak(u);
            }
        } finally { setLoading(false); }
    };

    return (
        <button
            type="button"
            onClick={play}
            aria-label={label}
            title={`${label} · AI voice — ask a family member or teacher to check`}
            className="inline-flex items-center justify-center rounded-full p-1.5 bg-lq-purple-100 text-lq-purple-700 hover:bg-lq-purple-500 hover:text-white transition-colors"
            data-testid={`speaker-${wordId || text?.slice(0,10)}`}
        >
            {loading ? <Loader2 size={size} className="animate-spin" /> : <Volume2 size={size} />}
        </button>
    );
}
